import Vue from 'vue';
import { handlerResponse } from '@/helpers/commonHelpers'

export default {
  namespaced: true,
  state: {
    customers: [],
    sellers: [],
    agents: [],
    suppliers: [],
    partners: [],
  },
  getters: {
    customers(state) {
      return state.customers;
    },
    sellers(state) {
      return state.sellers;
    },
    agents(state) {
      return state.agents;
    },
    suppliers(state) {
      return state.suppliers;
    }
  },
  mutations: {
    getCustomers(state, payLoad) {
      state.customers = payLoad;
    },
    getSellers(state, payLoad) {
      state.sellers = payLoad;
    },
    setAgents(state, payLoad) {
      state.agents = payLoad;
    },
    getSuppliers(state, payLoad) {
      state.suppliers = payLoad;
    },
    setPartners(state, payload) {
      state.partners = payload;
    }
  },
  actions: {
    async getCustomers(store) {
      try {
        const data = await Vue.http.get('partner/partners/short', {params: {role: 'customer'}}).then(handlerResponse)
        store.commit('getCustomers', data);
      } catch (exception) {
        console.log(exception)
      }
    },
    getSellers(store) {
      Vue.http.get('partner/partners/short', {params: {role: 'seller'}})
        .then(handlerResponse)
        .then(data => {
          store.commit('getSellers', data);
        });
    },
    getSaleAgents(store) {
      Vue.http.get('partner/partners/short', {params: {role: 'sale_agent'}})
        .then(handlerResponse)
        .then(data => {
          store.commit('setAgents', data);
        });
    },
    getPurchaseAgents(store) {
      Vue.http.get('partner/partners/short', {params: {role: 'purchase_agent'}})
        .then(handlerResponse)
        .then(data => {
          store.commit('setAgents', data);
        });
    },
    async getSuppliers(store) {
      try {
        const data = await Vue.http.get('partner/partners/short', {params: {role: 'supplier'}}).then(handlerResponse)
        store.commit('getSuppliers', data);
      } catch (exception) {
        console.log(exception);
      }
    },
    loadPartners({commit}) {
      return new Promise(resolve => {
        Vue.http.get(`partner/partners/short`)
          .then(handlerResponse)
          .then(data => {
            commit('setPartners', data);
            resolve(data);
          });
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/partners.js